import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "finish-selection__wrapper" }
const _hoisted_2 = { class: "finish-selection__switch-toggle" }
const _hoisted_3 = { class: "finish-selection__finish-list" }
const _hoisted_4 = { class: "finish-grid-list" }
const _hoisted_5 = { class: "finish-grid-list__item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SwitchToggle = _resolveComponent("SwitchToggle")!
  const _component_FinishItem = _resolveComponent("FinishItem")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_SwitchToggle, {
        isSelected: $options.isSynced,
        id: "doorFitFinderToggle",
        labelAlignment: "right",
        label: "Sync finish across all hardware:",
        onOnSwitchChange: $options.handleSwitchChange
      }, null, 8 /* PROPS */, ["isSelected", "onOnSwitchChange"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("ul", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.finishes, (finish, index) => {
          return (_openBlock(), _createElementBlock("li", _hoisted_5, [
            _createVNode(_component_FinishItem, _mergeProps(finish, { onUpdateSelection: $options.handleUpdateSelection }), null, 16 /* FULL_PROPS */, ["onUpdateSelection"])
          ]))
        }), 256 /* UNKEYED_FRAGMENT */))
      ])
    ])
  ]))
}